module.exports = __webpack_public_path__ + "img/no.b92ad796.svg";